function SvgContainerOrchestration(props) {
  return (
    <svg height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M1 6l11 4 11-4" />
        <path d="M23 19.25L12 23 1 19.25V5l11-3 11 3zM12 10.417v12.072" />
      </g>
    </svg>
  )
}

export default SvgContainerOrchestration
